import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import numeral from "numeral";
import moment from 'moment';

const styles = theme => ({
  table: {
    minWidth: 350,
    display: 'block',
    overflowY: 'auto',
    height: '200px',
  },
  root: {
    width: '100%',
    overflow: 'auto',
    // height: 230,
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  }
});

const PopupVehicleComp = (props) => {
  const {classes, rowHeight, data} = props
  return (
    // <Paper className={classes.root}>
    <Table className={classes.table}>
      <TableBody>
          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>License Plate</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.licensePlate ? data.licensePlate : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Location</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.location ? data.location : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Date/time</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.wpTime ? moment(data.wpTime).format("DD MMMM YYYY HH:mm:ss") : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Speed</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.speed ? `${data.speed} km/hour` : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Fuel Consumption</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.fuelConsumption ? data.fuelConsumption : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Odometer</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.odometer ? `${data.odometer} KM` : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Temperature</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.temperature ? data.temperature : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Engine Status</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.engineStatus ? data.engineStatus : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Pool Name</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.poolName ? data.poolName : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Company</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.companyName ? data.companyName : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>GSM No</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.gsmNo ? data.gsmNo : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>IMEI No</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.imeiNo ? data.imeiNo : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Status Vehicle</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.statusVehicle ? data.statusVehicle : "-"}</TableCell>
          </TableRow>

          <TableRow>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Tail</TableCell>
            <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.tail ? data.tail : "-"}</TableCell>
          </TableRow>
      </TableBody>
    </Table>
  // </Paper>
  )
}

const PopupInfoComp = (props) => {
  const {classes, rowHeight, data} = props
  return (
    // <Paper className={classes.root}>
    <Table className={classes.table}>
      <TableBody>
        <TableRow>
          <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Driver</TableCell>
          <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.driverName ? data.driverName : "-"}</TableCell>
        </TableRow>

        <TableRow>
          <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Code Rute</TableCell>
          <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.shipmentNumber ? data.shipmentNumber :"-"}</TableCell>
        </TableRow>

        <TableRow>
          <TableCell padding="dense" align="left" style={{ height: rowHeight }}>Remark</TableCell>
          <TableCell padding="dense" align="left" style={{ height: rowHeight }}>{data && data.remark ? data.remark : "-"}</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  // </Paper>
  )
}

const PopupInfo = withStyles( styles )(PopupInfoComp);
const PopupVehicle = withStyles( styles )(PopupVehicleComp);
export {
  PopupInfo,
  PopupVehicle,
}


// WEBPACK FOOTER //
// ./containers/ShareLocationPaxel/PopupMarker.js